var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiletypeDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 92,
    viewBox: "0 0 86 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.979 7.66669H21.4196C17.4927 7.66669 14.3155 11.1167 14.3155 15.3334L14.2798 76.6667C14.2798 80.8834 17.457 84.3334 21.3839 84.3334H64.2586C68.1855 84.3334 71.3985 80.8834 71.3985 76.6667V30.6667L49.979 7.66669ZM21.4196 76.6667V15.3334H46.409V34.5H64.2586V76.6667H21.4196Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiletypeDoc);
export default __webpack_public_path__ + "static/media/filetype-doc.1153a09d8a56ad25083cdc4b05b295d3.svg";
export { ForwardRef as ReactComponent };